// extracted by mini-css-extract-plugin
module.exports = {"input":"DevicesModule_input__3arb5","actions":"DevicesModule_actions__1Kwgi","table":"DevicesModule_table__1LxaK"};